export default "__VITE_ASSET__CsVbqxMY__"